import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeShowAsNonBookable } from "@App/state/reducers/filters";
import { z } from "zod";
import { State } from "@App/state";
import { zStringBoolean } from "@App/hooks/reactRouter/urlSchemas";
import { useSafeSearchParams } from "@App/hooks/reactRouter/useSafeSearchParams";

const schema = z.object({
  showAsNonBookable: zStringBoolean.optional(),
});

export const useShowAsNonBookableParams = () => {
  const showAsNonBookable = useSelector((state: State) => state.filters.showAsNonBookable);
  const dispatch = useDispatch();

  const safeSearchParams = useSafeSearchParams(schema);

  useEffect(() => {
    if (!safeSearchParams) return;

    const { showAsNonBookable: showAsNonBookableParam } = safeSearchParams;

    if (typeof showAsNonBookableParam !== "undefined") {
      dispatch(changeShowAsNonBookable(showAsNonBookableParam));
    }
  }, [safeSearchParams, dispatch]);

  const showAsNonBookableParams = () => ({
    ...(typeof showAsNonBookable !== "undefined" && showAsNonBookable !== null
      ? { showAsNonBookable: showAsNonBookable.toString() }
      : {}),
  });

  return { showAsNonBookableParams };
};
